import React from "react";
import AnalyticsTable from "../analyticsTable";
import { funnelSchema } from "./funnelSchema";
import { Card, CardContent } from "@mui/material";

function FunnelAnalyticsTable({ checkoutFunnelAnalysis }) {
  const updatedFailureTableData = checkoutFunnelAnalysis?.map((item) => ({
    Conversion_funnel: item.eventName,
    percentage2: item.eventPercent + "%",
    percentage2_sort: parseFloat(item.eventPercent),
    change: item?.changePercentage.toFixed(2) + "%",
    change_sort: parseFloat(item?.changePercentage),
    changeLocale: item?.absoluteChangePercentage.toFixed(2) + "%",
    changeLocale_sort: parseFloat(item?.absoluteChangePercentage),
    // count: item.eventNameCountLocale,
    count: item.eventNameCount,
    count_sort: item.eventNameCount,
  }));

  return (
    <AnalyticsTable
      style={{ marginTop: "0px" }}
      schema={funnelSchema}
      tableTitle="Checkout Funnel Analysis"
      data={updatedFailureTableData}
      default_orderBy={"count"}
    />
  );
}

export default FunnelAnalyticsTable;
